import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    view: 'Standby',
    sessionId: null,
    words: [],
    iconOptions: null,
    finalMeme: null,
    playSoundscape: false,
    errorMessage: null,
  },
  mutations: {
    addWord(state, word) {
      state.words.push(word);
    },
    reset(state) {
      state.sessionId = null;
      state.words = [];
      state.iconOptions = null;
      state.finalMeme = null;
      state.view = 'Standby';
      state.playSoundscape = false;
      state.errorMessage = null;
    },
    setFinalMeme(state, meme) {
      state.finalMeme = meme;
    },
    setIconOptions(state, iconOptions) {
      state.iconOptions = iconOptions;
    },
    setSessionId(state, id) {
      state.sessionId = id;
    },
    setView(state, view) {
      state.view = view;
    },
    setPlaySoundscape(state, status) {
      state.playSoundscape = status;
    },
    setErrorMessage(state, error) {
      try {
        state.errorMessage = `Error: ${error.response.data.message}`;
      } catch {
        state.errorMessage = error;
      }
    },
  },
  actions: {
  },
  modules: {
  },
});
